<template>
  <!--图片裁剪-->
  <tk-cover
    :show.sync="cropperCover"
    :hideOnClick="false"
    transition
    :through="false"
  >
    <clipper-fixed ref="clipper" class="cropper-basic" :src="userImg"></clipper-fixed>
    <tk-flex middle between class="cropper-action">
      <tkui-button class="tkui-dialog-button small m-0 p-b-3" @click="$emit('changCover', false)">取消裁剪</tkui-button>
      <tkui-button class="tkui-dialog-button small primary m-0 p-b-4" @click="cropperImage">裁剪上传</tkui-button>
    </tk-flex>
  </tk-cover>
</template>

<script>
export default {
  props: {
    cropperCover: {
      type: Boolean,
      default: false
    },
    userImg: {
      type: String,
      default: 'http://img3.imgtn.bdimg.com/it/u=1295149330,2951135297&fm=26&gp=0.jpg'
    }
  },
  methods: {
    // 将base64转换为文件
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /**
       * dataURL 转成 blob
       * @param dataURL
       * @return blob
       */
    dataURL2blob (dataURL) {
      let binaryString = atob(dataURL.split(',')[1])
      let arrayBuffer = new ArrayBuffer(binaryString.length)
      let intArray = new Uint8Array(arrayBuffer)
      let mime = dataURL.split(',')[0].match(/:(.*?);/)[1]
      for (let i = 0, j = binaryString.length; i < j; i++) {
        intArray[i] = binaryString.charCodeAt(i)
      }
      let data = [intArray]
      let result
      try {
        result = new Blob(data, { type: mime })
      } catch (error) {
        let BlobBuilder = window.BlobBuilder ||
            window.WebKitBlobBuilder ||
            window.MozBlobBuilder ||
            window.MSBlobBuilder
        if (error.name === 'TypeError' && window.BlobBuilder) {
          let builder = new BlobBuilder()
          builder.append(arrayBuffer)
          result = builder.getBlob(mime)
        } else {
          throw new Error('处理失败')
        }
      }
      return result
    },
    /**
       * 裁剪图片
       * @date: 2020/9/3
       */
    async cropperImage () {
      try {
        this.$emit('changCover', false) // 关闭弹框
        this.$emit('upLoadImage', { url: null, status: true })
        let time = new Date().getTime() // 获取时间戳
        const canvas = this.$refs.clipper.clip()
        const base64 = canvas.toDataURL('image/png', 1)
        const fileData = this.dataURLtoFile(base64, `zhongniu${time}.png`)
        let arrayBuffer = await fileData.arrayBuffer()
        const res = await this.$tkParse.post('/files', arrayBuffer)
        this.$emit('upLoadImage', { url: res.data.url, status: false })
      } catch (e) {
        this.$emit('upLoadImage', { url: null, status: false })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cropper-basic {
    width: 100%;
    height: 100%;
    ::v-deep .vuejs-clipper-basic__clip-area.js-clip-area {
      height: 100% !important;
    }
  }
  .cropper-action {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: #ffffff;
    border-top: 1px solid #f5f5f5;
  }
</style>
